import { EmailDatacenter } from '~/graphql/types';

export const getNylasDatacenter = (): {
  datacenter: EmailDatacenter;
  clientId: string;
} => ({
  datacenter: EmailDatacenter.Eu,
  clientId: process.env.NYLAS_V3_CLIENT_ID_EU ?? 'NYLAS_V3_CLIENT_ID_EU',
});
